import type { OwnerAndAssigneeType } from '@bb/domain/dist/types/SupraLockbox';

const buildLockboxAssignConfirmMessage = ({
  action,
  ownerType,
  assigneeType,
  isAssignee,
  listingAddress,
}: {
  action: 'Reassigning' | 'Unassigning';
  ownerType: OwnerAndAssigneeType;
  assigneeType?: OwnerAndAssigneeType;
  isAssignee: boolean;
  listingAddress?: string;
}) => {
  const ownerIsMLSOrBOR = ownerType === 'mls' || ownerType === 'board';
  const assigneeIsUser = assigneeType === 'user';

  let confirmMessage = '';

  if (!isAssignee) {
    confirmMessage =
      `${action} the Owner will clear the shackle permissions` +
      `${
        listingAddress
          ? `, and unassign the lockbox from listing ${listingAddress}`
          : `. The lockbox is not currently assigned to a listing`
      }`;
  } else if (!ownerIsMLSOrBOR && !assigneeIsUser) {
    confirmMessage = 'This Assignee will be removed';
  } else {
    confirmMessage += `${action} the Assignee will ${
      ownerIsMLSOrBOR ? 'clear the' : 'revoke their'
    } shackle permissions`;

    if (listingAddress) {
      confirmMessage += ownerIsMLSOrBOR
        ? `, and unassign the lockbox from listing ${listingAddress}`
        : `, and may remove the lockbox from listing ${listingAddress} if they are the listing agent for this listing`;
    } else {
      confirmMessage += '. The lockbox is not currently assigned to a listing';
    }
  }

  confirmMessage += '. Do you wish to continue?';
  return confirmMessage;
};

export default buildLockboxAssignConfirmMessage;
